import React from "react";

export default function EscalabilidadeBusiness() {
  return (
    <section className="text-white bg-[#040116]">
      <div className="container mx-auto max-w-[1080px] flex items-center justify-between gap-28 py-30 font-inter-regular">
        <div className="w-1/3">
          <h2 className="inline-block text-5xl">
            Da pesquisa à{" "}
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              escalabilidade
            </span>
          </h2>
        </div>
        <div className="w-2/3">
          <p className="leading-relaxed text-xl">
            Lideramos a implementação de metodologias e soluções ágeis personalizadas, conectando inovação e melhoria contínua para que seus projetos superem expectativas e gerem resultados de alto valor.
          </p>
        </div>
      </div>
    </section>
  );
}
